import React, { useEffect, useState } from 'react';
import styles from './survey.module.scss';
import { Widget } from '@typeform/embed-react'
import { gql, useMutation } from '@apollo/client';
import { UserFlags, UserRoleEnum } from '../../types';
import { useUser } from '../../hooks/useUser';
import { getCountryNameFromUserId } from '../../utils/helpers';
import { useHistory } from 'react-router-dom';

const updateUserFlags = gql`
  mutation UpdateUserFlag($flags: UserFlagsInput) {
    updateUserFlags(flags: $flags) {
      id, firstLoginFormFilled
    }
  }
`;

type UpdateUserFlagResponse = {
  updateUserFlags: UserFlags;
}

function Survey() {
  const [user, { loading, called }] = useUser();
  const { push } = useHistory();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!called || loading) return;
    if (!user) push('/login')
    else if (user.firstLoginFormFilled || user.role === 'SuperAdmin' || user.customer?.trial) {
      push('/')
    } else {
      setShow(true);
    }
  }, [user, loading, called, push]);

  const [updateUserFlag] = useMutation<UpdateUserFlagResponse>(updateUserFlags, {
    onError() {
      alert('Something went wrong!')
      push('/')
    },
    onCompleted() {
      push('/')
    }
  });

  const handleSubmit = () => {
    setShow(false);
    updateUserFlag({
      variables: {
        flags: {
          firstLoginFormFilled: true,
        }
      }
    });
  };

  return (
    <div className={styles.modalContent}>
      { show ? (
      <Widget
        id="G7xkKws1"
        className={styles.form}
        hidden={{
          // name: user?.firstName,
          school: (user?.schools ?? []).map(s => s?.name).join(', '),
          account: user?.customer?.name ?? '',
          role: user?.role || UserRoleEnum.User,
          country: getCountryNameFromUserId((user?.customer?.id ?? user?.id) || '')
        }}
        onSubmit={handleSubmit}
      /> ) : '' }
    </div>
  );
}

export default Survey;
